import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { TotemLabel } from '../TotemLabel';

export const DetailLink = ({
    label,
    sublabel,
    path,
    name,
    value,
    to,
    fontSize = '16px',
    fontWeight,
    color,
    shouldWrap = false,
}: {
    label?: string;
    sublabel?: string;
    // `path` builds the destination as `/${path}/${value}`. For routes that don't follow
    // that shape (e.g. a trailing segment like `/column/:id/stocks`), pass `to` instead.
    path?: string;
    name?: string;
    fontSize?: string;
    fontWeight?: string;
    value?: string | null;
    to?: string;
    color?: string;
    shouldWrap?: boolean;
}) => {
    const destination = to ?? (value ? `/${path}/${value}` : null);

    return (
        <Container>
            <TotemLabel>{label}</TotemLabel>
            {sublabel ? <Sublabel>{sublabel}</Sublabel> : null}
            {destination ? (
                <LinkWrapper $shouldWrap={shouldWrap}>
                    <StyledLink color={color} fontSize={fontSize} fontWeight={fontWeight} to={destination}>
                        {name || value}
                    </StyledLink>
                </LinkWrapper>
            ) : (
                <Value>-</Value>
            )}
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    overflow: hidden;
    flex-direction: column;
    color: ${({ theme }) => theme.textColor};
`;

const Sublabel = styled.span`
    color: ${({ theme }) => theme.infoTextColor};
    font-size: 13px;
`;

const LinkWrapper = styled.div<{ $shouldWrap: boolean }>`
    white-space: ${({ $shouldWrap }) => ($shouldWrap ? 'normal' : 'nowrap')};
    overflow: hidden;
`;

const StyledLink = styled(Link)<{ fontSize: string; fontWeight?: string }>`
    margin-top: 5px;
    color: ${({ theme, color }) => (color ? color : theme.ctaPrimaryHoveredColor)};
    text-decoration: none;
    font-size: ${({ fontSize }) => fontSize};
    font-weight: ${({ fontWeight }) => fontWeight || 'normal'};
    text-overflow: ellipsis;
    overflow: hidden;
    &:hover {
        text-decoration: underline;
    }
`;

const Value = styled.span`
    margin-top: 5px;
    color: ${({ theme }) => theme.textColor};
`;
